export const interpertDream = [
  {
    path: '/Admin/interpertDream/preliminaryExamination',
    name: '初审列表',
    component: () => import('./preliminaryExamination/index.vue'),
    meta: {
      title: '初审列表'
    }
  }, {
    path: '/Admin/interpertDream/preliminaryExamination/details',
    name: '初审详情',
    component: () => import('./preliminaryExamination/details.vue'),
    meta: {
      title: '初审详情'
    }
  }, {
    path: '/Admin/interpertDream/generalreview',
    name: '全国总展演审核列表',
    component: () => import('./generalreview/index.vue'),
    meta: {
      title: '全国总展演审核列表'
    }
  }, {
    path: '/Admin/interpertDream/generalreview/details',
    name: '全国总展演审核详情',
    component: () => import('./generalreview/details.vue'),
    meta: {
      title: '全国总展演审核详情'
    }
  }, {
    path: '/Admin/interpertDream/price',
    name: '价格管理',
    component: () => import('./price/index.vue'),
    meta: {
      title: '价格管理'
    }
  }, {
    path: '/Admin/interpertDream/speciality',
    name: '专业管理',
    component: () => import('./speciality/index.vue'),
    meta: {
      title: '专业管理'
    }
  }
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/interpertDream/routes.js